import { TournamentCategory } from '../types/tournament';
import { toBoolean } from './common.helpers';
import { categoryRubberCount } from './teamCategoryRubberCount';

export function getAvailableCategoriesForCell(
  cellMatches: {
    tournamentCategory?: { id?: number };
    tournamentCategoryId: number | null;
  }[],
  categories: TournamentCategory[]
): TournamentCategory[] {
  const usedCounts = new Map<number, number>();
  for (const m of cellMatches) {
    const cid = m.tournamentCategory?.id ?? m.tournamentCategoryId;
    if (typeof cid === 'number') {
      usedCounts.set(cid, (usedCounts.get(cid) ?? 0) + 1);
    }
  }

  return categories.filter((cat) => {
    if (typeof cat.id !== 'number') {
      return false;
    }
    if (!toBoolean(cat.isActive)) {
      return false;
    }
    const max = categoryRubberCount(cat.numberOfMatches);
    const used = usedCounts.get(cat.id) ?? 0;
    return used < max;
  });
}
